const hostname = window.location.hostname;
const isDevelopment = process.env.NODE_ENV === 'development';

const normalizeBaseUrl = (url) => (url || '').replace(/\/+$/, '');

export const BASE_URL = isDevelopment
  ? 'http://localhost:8001'
  : `https://${hostname}`;

const defaultDeliverectBaseUrl = isDevelopment
  ? 'http://localhost:8000'
  : 'https://api.pos-max.com';

export const DELIVERECT_API_BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_DELIVERECT_API_BASE || defaultDeliverectBaseUrl
);

export const DELIVERECT_ACCOUNT_INFO_URL = (posUuid = '') => {
  const query = posUuid ? `?pos_uuid=${encodeURIComponent(posUuid)}` : '';
  return `/deliverect/accounts/${query}`;
};
export const DELIVERECT_STORE_INFO_URL = (posUuid = '') => {
  const query = posUuid ? `?pos_uuid=${encodeURIComponent(posUuid)}` : '';
  return `/deliverect/store-info/${query}`;
};
export const DELIVERECT_STORE_INFO_DETAIL_URL = (id) => {
  return `/deliverect/store-info/${id}/`;
};

// PUBLIC ENDPOINTS
export const USER_LOGIN_URL = `/auth/login/`;
export const USER_GOOGLE_LOGIN_URL = '/auth/social/google-oauth2/';
export const USER_REGISTRATION_URL = `/auth/registration/`;
export const USER_LOGOUT_URL = `/auth/logout/`;
export const USER_PASS_FORGET_URL = `/auth/password/reset/`;
export const USER_PASS_RESET_URL = `/auth/password/reset/confirm/`;
export const USER_DETAILS_URL = `/api/v1/user`;
export const USER_DEVICES_URL = `/api/v1/devices`;
export const USER_STORE_URL = `/api/v1/user/stores`;

export const STORE_URL = (uuid) => {
  return `/api/v1/user/stores/${uuid}`;
};

export const INVENTORY_URL = (uuid, deptId = '') => {
  const deptParam = deptId ? `?dept_id=${deptId}` : '';
  return `/api/v1/inventory/${uuid}${deptParam}`;
};
export const INVENTORY_ITEM_URL = (item, uuid) => {
  return `/api/v1/inventory/item/${uuid}/${item}`;
};

export const PRINT_LABEL_URL = (uuid, item = '') => {
  return item
    ? `/api/v1/inventory/print-label/${uuid}/${item}`
    : `/api/v1/inventory/print-label/${uuid}/`;
};

export const SEARCH_ITEM_URL = (uuid, keywords, department = '') => {
  const searchKeyword = keywords || '-';
  const deptParam = department ? `?department=${department}` : '';
  return `/api/v1/inventory/${uuid}/search/${searchKeyword}${deptParam}`;
};

export const INVENTORY_REMOVE_ITEM_URL = (item) => {
  return `/api/v1/inventory/remove/${item}`;
};
export const DEPARTMENT_LIST_URL = (uuid) => {
  return `/api/v1/inventory/${uuid}/departments`;
};
export const INVENTORY_ADD_UPDATE_URL = `/api/v1/inventory/add-update/`;
export const INVENTORY_BULK_UPDATE_URL = (uuid) =>
  `/api/v1/inventory/${uuid}/bulk-update/`;
export const STATUS_OPTIONS = [
  { key: 'all', label: 'All Sync Statuses', color: 'default' },
  { key: 'core_synced', label: 'Synced', color: 'success' },
  { key: 'core_syncing', label: 'Syncing', color: 'info' },
  { key: 'core_ignored', label: 'Ignored', color: 'warning' },
  { key: 'core_failed', label: 'Failed', color: 'error' },
];
export const CORE_FLAG_OPTIONS = [
  { key: 'core_synced', label: 'Synced', color: 'success' },
  { key: 'core_syncing', label: 'Syncing', color: 'info' },
  { key: 'core_ignored', label: 'Ignored', color: 'warning' },
  { key: 'core_failed', label: 'Failed', color: 'error' },
];
export const TASK_STATUS_URL = (taskId, uuid) => {
  return `/api/v1/tasks/${taskId}/status/${uuid}`;
};

export const USER_STORE_UPDATE_URL = (id) => {
  return `/api/v1/user/stores/${id}/update/`;
};
export const USER_STORE_ONBOARD_URL = (uuid) => {
  return `/api/v1/store/${uuid}/onboard`;
};

export const USER_STORE_PAYMENT_URL = (uuid) => {
  return `/api/v1/store/${uuid}/pay`;
};

export const MENU_SYNC_URL = (uuid, item_num = '') => {
  return `/api/v1/sync/item/${uuid}/${item_num}`;
};

export const MENU_UNSYNC_URL = (uuid) => {
  return `/api/v1/unsync/item/${uuid}`;
};
export const MENU_UNSYNC_ITEM_URL = (uuid, bevz_product_id) => {
  return `/api/v1/unsync/item/${uuid}/${bevz_product_id}`;
};
export const USER_POS_DELETE_URL = (uuid) => {
  return `/api/v1/pos/delete/${uuid}`;
};

export const REGISTER_DEVICE_URL = () => {
  return `/api/v1/register-device/`;
};

export const PROVISION_STORE_URL = (id) => {
  return `/api/v1/user/stores/provision/${id}/`;
};

export const SALE_INVOICE_URL = (uuid, item_num) => {
  return `/api/v1/upload-sale/${uuid}/?item_num=${item_num}`;
};

export const MIXNMATCH_URL = (uuid) => {
  return `/api/v1/mixnmatch/${uuid}/`;
};

export const MIXNMATCH_DELETE_URL = (uuid) => {
  return `/api/v1/mixnmatch/delete/${uuid}/`;
};

export const UBER_EATS_GENERATE_OAUTH_URL = (store_id) => {
  return `/api/v1/uber-eat/generate-oauth/${store_id}/`;
};

export const UBER_EATS_CALLBACK_URL = (uuid) => {
  return `/api/v1/uber-eat/exchange-and-provision/${uuid}`;
};

// For testing purpose only
export const TEST_ORDER_HOOK = `/api/v1/order/test/`;
export const ORDER_HOOK = `/api/v1/order/hook/`;

// TOKENS
export const REFRESH_TOKEN_URL = `/auth/token/refresh/`;

// LOCALSTORAGE & DEV KEYS
export const DEV_AUTH_TOKEN_KEY = 'test_dev_auth';
export const DEV_REFRESH_TOKEN_KEY = 'test_dev_ref';
export const LS_POS_LIST = 'LS_POS';
export const LS_DELIVERECT_STORE_INFO = 'LS_DELIVERECT_STORE_INFO';

// APP VERSION
export const APP_VERSION = '0.0.1a';
